import { MOSCOW, MOSCOW_REGION } from '../../constants/regions';

export const isMiMO = (locationId: number) => {
  return [MOSCOW, MOSCOW_REGION].includes(locationId);
};
